<!--
  navItem "Matrizen" — the matrix family of this provision type.

  Left:  the matrices of this provision type (selectable). cp.ProvisionTypeMatrix owns exactly one
         configuration child, so the selectable parent pattern is the prescribed form here.
  Right: level 2, built ONLY once a matrix is selected — the matrix rows
         (cp.ProvisionTypeMatrixAgent) plus the assignment rules that route onto it
         (cp.ProvisionTypeMatrixAssignment). The latter is a matrix-scoped view; the full rule set
         is maintained on the navItem "Matrix-Zuordnung". Without a selection both widgets are
         null and the hint below takes their place (04-frontend.md §6).
-->
<div class="cp-provision-type-matrix">

    @if (initialized && matrixWidget) {
        <div class="grid m-0">

            <div class="col-12 md:col-4 p-2 pt-0">
                <mvs-widget
                        [widgetData]="matrixWidget"
                        [importObjectContext]="matrixImportContext"
                        (onObjectSelect)="onMatrixSelect($event)"
                        (onObjectDeselect)="onMatrixDeselect()">
                </mvs-widget>
            </div>

            <div class="col-12 md:col-8 p-2 pt-0">

                @if (matrixAgentWidget) {
                    <mvs-widget
                            [widgetData]="matrixAgentWidget"
                            [importObjectContext]="matrixAgentImportContext">
                    </mvs-widget>

                    @if (matrixAssignmentWidget) {
                        <div class="mt-3">
                            <mvs-widget
                                    [widgetData]="matrixAssignmentWidget"
                                    [importObjectContext]="matrixAssignmentImportContext">
                                <ng-template let-object="object" mvs-widget-custom-field-directive
                                             area="columns" [fieldId]="conditionSetFieldId" label="Bedingungssatz">
                                    @if (conditionSetName(object); as setName) {
                                        <span>{{ setName }}</span>
                                    } @else {
                                        <span class="text-color-secondary font-italic">{{ unconditionalLabel }}</span>
                                    }
                                </ng-template>
                            </mvs-widget>
                        </div>
                    }
                } @else {
                    <p-message
                            severity="info"
                            text="Bitte eine Provisionsmatrix auswählen."
                            styleClass="w-full">
                    </p-message>
                }

            </div>

        </div>
    } @else if (initialized) {
        <p-message severity="info" text="Kein Provisionstyp ausgewählt." styleClass="w-full"></p-message>
    } @else {
        <p-skeleton height="12rem"></p-skeleton>
    }

</div>
